import "./Services.module.css";
import Navigation from "@/reusable_sections/Header";
import ForgeYourInfluence from "./sections/ForgeYourInfluence";
import TheCapabilityGrid from "./sections/TheCapabilityGrid";
import CommonQuestions from "./sections/CommonQuestions";
import Footer from "@/reusable_sections/Footer";
export default function ServicesPage() {
  return <div>
      <Navigation />
      <ForgeYourInfluence />
      <TheCapabilityGrid />
      <CommonQuestions />
      <Footer />
    </div>;
}